export const addressTooltipText = (address, header) => {
    if (!address) {
        return '';
    }
    return (
        <div style={{ textAlign: 'left' }}>
            {header && (
                <div>
                    <b>{header}</b>
                </div>
            )}
            {address.street1}
            {address.street2 && <div style={{ textAlign: 'left' }}>{address.street2}</div>}
            {(address.city || address.state || address.zipCode) && (
                <div>
                    {address.city}, {address.state} {address.zipCode}
                </div>
            )}
        </div>
    );
};
